/**
 * Defines the type for client data
 */
export interface ClientDataItem {
    ActivityId: number;
    ClientMasterId: number;
    ClientName: string;
    ClientId: string;
    Office: string;
    ClientType: string;
    ImportStatus?: string;
}

export type ClientScope = "k1" | "all";

export const K1_CLIENTS_KEY = "k1";

export type ClientsPageProps = {
  transporter: (pill: string, options?: any) => void;
};
